module.exports = __webpack_public_path__ + "img/20190809162131053.fa935eaf.png";